
// 量表任务相关API
import apiClient from './config'

/**
 * 量表任务API类
 */
export class ScaleApi {
  /**
   * 指定量表任务给患者
   * @param {Object} taskData - 任务数据
   * @param {number} taskData.doctorId - 医生ID
   * @param {number} taskData.userId - 患者ID
   * @param {number} taskData.scaleId - 量表ID
   * @param {string} [taskData.deadline] - 任务截止时间（ISO 8601格式）
   * @param {string} [taskData.remark] - 任务备注
   * @param {string} taskData.taskPublishTime - 任务发布时间（ISO 8601格式）
   * @returns {Promise<Object>} 分配结果
   */
  async assignScaleTask(taskData) {
    try {
      console.log('调用分配量表任务API:', taskData)

      // 验证必填参数
      if (!taskData.doctorId || !taskData.userId || !taskData.scaleId || !taskData.taskPublishTime) {
        return {
          success: false,
          message: '缺少必填参数：doctorId、userId、scaleId、taskPublishTime'
        }
      }

      // 构建请求数据，严格按照接口文档格式
      const requestData = {
        doctorId: parseInt(taskData.doctorId),
        userId: parseInt(taskData.userId),
        scaleId: parseInt(taskData.scaleId),
        taskPublishTime: taskData.taskPublishTime
      }

      // 添加可选参数
      if (taskData.deadline) {
        requestData.deadline = taskData.deadline
      }
      if (taskData.remark) {
        requestData.remark = taskData.remark
      }

      console.log('发送分配量表任务请求数据:', requestData)

      // 调用后端分配量表任务接口
      const response = await apiClient.post('/scale/response/task/assign', requestData)

      // 检查响应数据结构
      const data = response.data
      console.log('分配量表任务API响应详情:', data)

      // 根据接口文档，code为0表示成功
      if (data.code === 0) {
        return {
          success: true,
          message: data.message || '分配量表任务成功',
          data: data.data || {}
        }
      } else {
        // 分配失败
        const errorMessage = data.message || '分配量表任务失败'
        console.warn('分配量表任务失败:', errorMessage)

        return {
          success: false,
          message: errorMessage,
          errorCode: data.code,
          data: null
        }
      }
    } catch (error) {
      console.error('分配量表任务异常:', error)

      if (error.response) {
        // 服务器返回了错误响应
        const errorData = error.response.data
        const errorMessage = errorData?.message || `服务器错误 (${error.response.status})`

        return {
          success: false,
          message: errorMessage,
          errorCode: error.response.status
        }
      } else if (error.request) {
        // 请求发送了但没有收到响应
        return {
          success: false,
          message: '网络连接失败，请检查网络'
        }
      } else {
        // 其他错误
        return {
          success: false,
          message: error.message || '分配量表任务失败，请重试'
        }
      }
    }
  }

  /**
   * 根据标签分配量表任务
   * @deprecated 此功能已暂时移除
   * @param {Object} taskData - 任务数据
   * @param {number} taskData.doctorId - 医生ID
   * @param {number} taskData.tagId - 标签ID
   * @param {number} taskData.scaleId - 量表ID
   * @param {string} [taskData.deadline] - 任务截止时间（ISO 8601格式）
   * @param {string} [taskData.remark] - 任务备注
   * @param {string} taskData.taskPublishTime - 任务发布时间（ISO 8601格式）
   * @returns {Promise<Object>} 分配结果
   */
  // async assignScaleTaskByTag(taskData) {
  //   try {
  //     console.log('=== 根据标签分配量表任务 ===')
  //     console.log('调用参数:', taskData)

  //     // 验证必填参数
  //     if (!taskData.doctorId || !taskData.tagId || !taskData.scaleId || !taskData.taskPublishTime) {
  //       return {
  //         success: false,
  //         message: '缺少必填参数：doctorId、tagId、scaleId、taskPublishTime'
  //       }
  //     }

  //     // 构建请求数据，严格按照接口文档格式
  //     const requestData = {
  //       doctorId: parseInt(taskData.doctorId),
  //       tagId: parseInt(taskData.tagId),
  //       scaleId: parseInt(taskData.scaleId),
  //       taskPublishTime: taskData.taskPublishTime
  //     }

  //     // 添加可选参数
  //     if (taskData.deadline) {
  //       requestData.deadline = taskData.deadline
  //     }
  //     if (taskData.remark) {
  //       requestData.remark = taskData.remark
  //     }

  //     console.log('发送请求到 /scale/response/task/assign-by-tag')
  //     console.log('请求体:', requestData)

  //     // 调用后端根据标签分配量表任务接口
  //     const response = await apiClient.post('/scale/response/task/assign-by-tag', requestData)

  //     // 检查响应数据结构
  //     const data = response.data
  //     console.log('根据标签分配量表任务API响应:', data)

  //     // 根据接口文档，code为0表示成功
  //     if (data.code === 0) {
  //       console.log('✅ 根据标签分配量表任务成功')
  //       console.log('📊 创建的任务列表:', data.data)

  //       return {
  //         success: true,
  //         message: data.message || '根据标签分配量表任务成功',
  //         data: data.data || []
  //       }
  //     } else {
  //       // 分配失败
  //       const errorMessage = data.message || '根据标签分配量表任务失败'
  //       console.warn('❌ 根据标签分配量表任务失败:', errorMessage)

  //       return {
  //         success: false,
  //         message: errorMessage,
  //         errorCode: data.code,
  //         data: null
  //       }
  //     }
  //   } catch (error) {
  //     console.error('❌ 根据标签分配量表任务异常:', error)

  //     if (error.response) {
  //       // 服务器返回了错误响应
  //       const errorData = error.response.data
  //       const errorMessage = errorData?.message || `服务器错误 (${error.response.status})`

  //       return {
  //         success: false,
  //         message: errorMessage,
  //         errorCode: error.response.status
  //       }
  //     } else if (error.request) {
  //       // 请求发送了但没有收到响应
  //       return {
  //         success: false,
  //         message: '网络连接失败，请检查网络'
  //       }
  //     } else {
  //       // 其他错误
  //       return {
  //         success: false,
  //         message: error.message || '根据标签分配量表任务失败，请重试'
  //       }
  //     }
  //   }
  // }

  /**
   * 获取患者量表任务详情
   * 根据接口文档：/scale/response/user/tasks
   * @param {number} userId - 患者ID
   * @returns {Promise<Object>} 量表任务详情
   */
  async getPatientScaleTaskDetail(userId) {
    try {
      console.log('调用获取患者量表任务详情API:', userId)

      if (!userId) {
        return {
          success: false,
          message: '患者ID不能为空'
        }
      }

      // 根据接口文档，使用GET请求，userId作为query参数
      const response = await apiClient.get('/scale/response/user/tasks', {
        params: {
          userId: parseInt(userId)
        }
      })

      // 检查响应数据结构
      const data = response.data
      console.log('获取患者量表任务详情API响应详情:', data)

      // 根据接口文档，code为0表示成功
      if (data.code === 0) {
        return {
          success: true,
          message: data.message || '获取量表任务详情成功',
          data: data.data || {}
        }
      } else {
        // 获取失败
        const errorMessage = data.message || '获取量表任务详情失败'
        console.warn('获取量表任务详情失败:', errorMessage)

        return {
          success: false,
          message: errorMessage,
          errorCode: data.code,
          data: null
        }
      }
    } catch (error) {
      console.error('获取患者量表任务详情异常:', error)

      if (error.response) {
        // 服务器返回了错误响应
        const errorData = error.response.data
        const errorMessage = errorData?.message || `服务器错误 (${error.response.status})`

        return {
          success: false,
          message: errorMessage,
          errorCode: error.response.status,
          data: null
        }
      } else if (error.request) {
        // 请求发送了但没有收到响应
        return {
          success: false,
          message: '网络连接失败，请检查网络',
          data: null
        }
      } else {
        // 其他错误
        return {
          success: false,
          message: error.message || '获取量表任务详情失败，请重试',
          data: null
        }
      }
    }
  }

  /**
   * 查询量表填写记录详情
   * @param {number} recordId - 记录ID
   * @returns {Promise<Object>} 填写记录详情
   */
  async getScaleResponseResult(recordId) {
    try {
      console.log('调用查询量表填写记录API:', recordId)

      if (!recordId) {
        return {
          success: false,
          message: '记录ID不能为空'
        }
      }

      // 调用后端查询量表填写记录接口
      const response = await apiClient.get(`/scale/response/result/${recordId}`)

      // 检查响应数据结构
      const data = response.data
      console.log('查询量表填写记录API响应详情:', data)

      // 根据接口文档，code为0表示成功
      if (data.code === 0) {
        return {
          success: true,
          message: data.message || '获取量表填写记录成功',
          data: data.data || {}
        }
      } else {
        // 获取失败
        const errorMessage = data.message || '获取量表填写记录失败'
        console.warn('获取量表填写记录失败:', errorMessage)

        return {
          success: false,
          message: errorMessage,
          errorCode: data.code,
          data: null
        }
      }
    } catch (error) {
      console.error('查询量表填写记录异常:', error)

      if (error.response) {
        // 服务器返回了错误响应
        const errorData = error.response.data
        const errorMessage = errorData?.message || `服务器错误 (${error.response.status})`

        return {
          success: false,
          message: errorMessage,
          errorCode: error.response.status
        }
      } else if (error.request) {
        // 请求发送了但没有收到响应
        return {
          success: false,
          message: '网络连接失败，请检查网络'
        }
      } else {
        // 其他错误
        return {
          success: false,
          message: error.message || '获取量表填写记录失败，请重试'
        }
      }
    }
  }

  /**
   * 获取患者的量表任务列表（包含截止时间等任务信息）
   * 注意：这个方法获取的是任务列表，不是已完成的记录
   * @param {number} patientId - 患者ID
   * @param {Object} [queryParams] - 查询参数
   * @returns {Promise<Object>} 量表任务列表
   */
  async getPatientScaleTasks(patientId, queryParams = {}) {
    try {
      if (!patientId) {
        return {
          success: false,
          message: '患者ID不能为空'
        }
      }

      // 使用正确的API端点：/scale/response/doctor/tasks
      const endpoint = '/scale/response/doctor/tasks'

      // 构建请求参数，符合接口文档要求
      const params = {
        current: queryParams.current || 1, // 当前页码，默认1
        size: queryParams.size || 50, // 每页大小，默认50（获取更多数据）
        patientId: parseInt(patientId), // 患者ID
        ...queryParams // 其他额外参数
      }

      const response = await apiClient.get(endpoint, {
        params: params
      })

      // 检查响应数据结构
      const data = response.data

      // 根据接口文档，code为0表示成功
      if (data.code === 0) {
        // 根据接口文档，data.records是任务数组，data.total是总数
        let taskList = []

        if (data.data && data.data.records && Array.isArray(data.data.records)) {
          taskList = data.data.records
        }

        // 转换数据格式以适配前端显示
        const formattedTasks = taskList.filter(task => task != null).map((task, index) => {
          // 检查必要字段是否存在
          if (!task || typeof task !== 'object') {
            return null
          }

          // 格式化时间函数
          const formatDateTime = (dateTimeStr) => {
            if (!dateTimeStr) return ''

            try {
              const date = new Date(dateTimeStr)
              if (isNaN(date.getTime())) {
                console.warn('无效的时间格式:', dateTimeStr)
                return dateTimeStr // 如果无法解析，返回原始字符串
              }

              // 格式化为 YYYY-MM-DD HH:mm:ss
              const year = date.getFullYear()
              const month = String(date.getMonth() + 1).padStart(2, '0')
              const day = String(date.getDate()).padStart(2, '0')
              const hours = String(date.getHours()).padStart(2, '0')
              const minutes = String(date.getMinutes()).padStart(2, '0')
              const seconds = String(date.getSeconds()).padStart(2, '0')

              return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
            } catch (error) {
              console.error('时间格式化失败:', error, dateTimeStr)
              return dateTimeStr
            }
          }

          // 智能状态判断
          const getTaskStatus = (task) => {
            // 优先使用后端返回的状态字段
            if (task.status) {
              return task.status
            }

            // 如果后端没有状态字段，根据其他字段推断
            if (task.submitTime) {
              return '已完成'
            }

            // 检查是否有截止时间，判断是否过期
            if (task.deadline) {
              const now = new Date()
              const deadlineDate = new Date(task.deadline)
              if (!isNaN(deadlineDate.getTime()) && deadlineDate < now) {
                return '已过期'
              }
            }

            return '未完成'
          }

          // 获取截止时间，尝试多个可能的字段名
          const getDeadline = (task) => {
            console.log('🔍 API层 - 分析任务截止时间字段:')
            console.log('任务完整数据:', JSON.stringify(task, null, 2))

            // 按优先级排序，确保真正的截止时间字段优先于updateTime等字段
            const possibleDeadlineFields = [
              'deadline', // 截止时间 - 最高优先级（正确的字段）
              'taskDeadline', // 任务截止时间
              'completionDeadline', // 完成截止时间
              'taskEndTime', // 任务结束时间
              'dueDate', // 到期日期
              'expireTime', // 过期时间
              'timeLimit', // 时间限制
              'limitTime', // 限制时间
              'taskLimit', // 任务限制
              'finishTime', // 完成时间
              'endTime', // 结束时间
              'taskPublishTime', // 任务发布时间
              'publishTime', // 发布时间
              'assignTime', // 分配时间
              'planTime', // 计划时间
              'scheduleTime', // 调度时间
              'startTime', // 开始时间
              // 注意：createTime和updateTime应该放在最后，避免错误映射
              'createTime', // 创建时间 - 低优先级
              'updateTime' // 更新时间 - 最低优先级
            ]

            console.log('逐个检查可能的截止时间字段:')
            possibleDeadlineFields.forEach(field => {
              const value = task[field]
              console.log(`  ${field}:`, value, `(类型: ${typeof value})`)
            })

            // 查找所有时间相关字段
            const allFields = Object.keys(task)
            const timeFields = allFields.filter(field =>
              field.toLowerCase().includes('time') ||
              field.toLowerCase().includes('date') ||
              field.toLowerCase().includes('deadline') ||
              field.toLowerCase().includes('limit') ||
              field.toLowerCase().includes('expire') ||
              field.toLowerCase().includes('due')
            )
            console.log('所有时间相关字段:', timeFields)

            for (const field of possibleDeadlineFields) {
              console.log(`🔍 API层检查字段 ${field}:`, {
                value: task[field],
                type: typeof task[field],
                isNull: task[field] === null,
                isUndefined: task[field] === undefined,
                isEmpty: task[field] === '',
                truthyCheck: !!task[field]
              })

              if (task[field] && task[field] !== null && task[field] !== undefined && task[field] !== '') {
                console.log(`✅ API层找到截止时间字段 ${field}:`, task[field])
                // 特别标记如果使用了updateTime，这可能是错误的映射
                if (field === 'updateTime') {
                  console.warn('⚠️ API层警告：使用了updateTime作为截止时间，这可能不是正确的完成时间')
                }
                return task[field]
              } else {
                console.log(`❌ API层字段 ${field} 不可用`)
              }
            }

            console.warn('❌ API层未找到有效的截止时间字段')
            console.warn('所有可用字段:', Object.keys(task))
            console.warn('所有字段值:', task)
            return null
          }

          const rawDeadline = getDeadline(task)
          const formattedDeadline = formatDateTime(rawDeadline)

          // 格式化后的任务数据（根据接口文档字段）
          const formattedTask = {
            id: task.id || `temp-${index}`, // 任务记录ID，如果没有则使用临时ID
            taskId: task.id || `temp-${index}`, // 任务ID（用于操作）
            scaleName: task.scaleName || '未知量表', // 量表名称
            scaleId: task.scaleId || 0, // 量表ID
            userId: task.userId || 0, // 患者ID
            userName: task.userName || '未知患者', // 患者姓名
            status: task.status || '未知状态', // 任务状态（未完成 / 已完成）
            spendTime: task.spendTime || null, // 答题耗时（秒）
            score: task.score || null, // 量表得分
            resultExplain: task.resultExplain || '', // 结果解释
            submitTime: formatDateTime(task.submitTime) || '', // 格式化患者提交时间
            taskPublishTime: formatDateTime(task.taskPublishTime) || '', // 格式化医生发布时间
            // 为了兼容现有的前端代码，添加一些额外字段
            name: task.scaleName || '未知量表', // 兼容字段
            deadline: formattedDeadline || formatDateTime(task.taskPublishTime) || '', // 使用智能提取的截止时间，如果没有则使用任务发布时间
            remark: task.resultExplain || '', // 备注使用结果解释
            // 保留原始数据以便调试
            originalData: task
          }

          return formattedTask
        }).filter(task => task !== null) // 过滤掉null值

        return {
          success: true,
          message: data.message || '获取量表任务列表成功',
          data: formattedTasks,
          total: data.data?.total || formattedTasks.length,
          current: params.current,
          size: params.size
        }
      } else {
        // 获取失败
        const errorMessage = data.message || '获取量表任务列表失败'

        return {
          success: false,
          message: errorMessage,
          errorCode: data.code,
          data: []
        }
      }
    } catch (error) {
      console.error('获取患者量表任务列表异常:', error)

      if (error.response) {
        // 服务器返回了错误响应
        const status = error.response.status
        const errorData = error.response.data

        if (status === 404) {
          // 接口不存在，返回空数据但不显示错误
          console.warn('患者量表任务接口不存在，返回空数据')
          return {
            success: true,
            message: '暂无量表任务数据',
            data: []
          }
        } else if (status === 500) {
          // 服务器内部错误
          console.error('服务器内部错误:', errorData)
          const errorMsg = errorData?.message || errorData?.msg || '服务器内部错误'

          // 只有明确表示"无数据"的500错误才当作成功
          const isNoDataError = errorMsg.includes('没有数据') ||
                                errorMsg.includes('未找到') ||
                                errorMsg.includes('不存在') ||
                                errorMsg.includes('无记录')

          if (isNoDataError) {
            console.log('ℹ️ 500错误但是无数据情况，不视为错误')
            return {
              success: true,
              message: '暂无量表任务数据',
              data: []
            }
          }

          // 真正的500错误应该显示
          console.error('🔴 真实的500服务器错误:', errorMsg)
          return {
            success: false,
            message: `服务器错误: ${errorMsg}`,
            errorCode: 500,
            data: []
          }
        } else {
          const errorMessage = errorData?.message || `服务器错误 (${status})`
          return {
            success: false,
            message: errorMessage,
            errorCode: status,
            data: []
          }
        }
      } else if (error.request) {
        // 请求发送了但没有收到响应
        return {
          success: false,
          message: '网络连接失败，请检查网络',
          data: []
        }
      } else {
        // 其他错误
        return {
          success: false,
          message: error.message || '获取量表任务列表失败，请重试',
          data: []
        }
      }
    }
  }

  /**
   * 获取医生可以下发的量表列表（用于新增量表任务）
   * 根据接口文档：/scale/query-any
   * @param {Object} [queryParams] - 查询参数
   * @param {number} [queryParams.pageNum] - 当前页码（从0开始）
   * @param {number} [queryParams.pageSize] - 每页条数
   * @param {Object} [queryParams.queryParams] - 查询条件
   * @param {string} [queryParams.queryParams.status] - 启用状态（启用中/未启用）
   * @returns {Promise<Object>} 量表列表
   */
  async getAvailableScalesForAssign(queryParams = {}) {
    try {
      console.log('调用获取医生可下发量表列表API:', queryParams)

      // 构建请求参数，默认只获取启用中的量表
      const requestBody = {
        pageNum: queryParams.pageNum || 0,
        pageSize: queryParams.pageSize || 100, // 设置较大的pageSize以获取所有可用量表
        queryParams: {
          status: '启用中', // 只获取启用中的量表
          ...queryParams.queryParams
        }
      }

      console.log('构建的请求参数:', requestBody)

      // 调用后端获取量表列表接口
      const response = await apiClient.post('/scale/query-any', requestBody)

      // 检查响应数据结构
      const data = response.data
      console.log('获取医生可下发量表列表API响应详情:', data)
      console.log('响应状态码:', response.status)

      // 根据接口文档，code为0表示成功
      if (data.code === 0) {
        // 确保返回的数据格式符合前端需要
        const records = data.data?.records || []
        console.log('原始量表数据条数:', records.length)

        // 转换数据格式以适配前端显示，过滤掉无效数据
        const formattedScales = records
          .filter(scale => scale && typeof scale === 'object' && scale.id)
          .map((scale, index) => {
            console.log(`处理第${index + 1}个量表:`, scale)

            return {
              id: scale.id,
              name: scale.name || '',
              code: scale.code || '',
              type: scale.type || '',
              status: scale.status || '',
              scoreExplain: scale.scoreExplain || '',
              description: scale.description || '',
              instruction: scale.instruction || '',
              createTime: scale.createTime || '',
              updateTime: scale.updateTime || ''
            }
          })

        console.log('格式化后的量表数据:', formattedScales)

        return {
          success: true,
          message: data.message || '获取量表列表成功',
          data: formattedScales,
          total: data.data?.total || formattedScales.length,
          pagination: {
            current: data.data?.current || 0,
            size: data.data?.size || formattedScales.length,
            pages: data.data?.pages || 1,
            total: data.data?.total || formattedScales.length
          }
        }
      } else {
        // 获取失败
        const errorMessage = data.message || '获取量表列表失败'
        console.warn('获取医生可下发量表列表失败:', errorMessage)

        return {
          success: false,
          message: errorMessage,
          errorCode: data.code,
          data: [],
          total: 0
        }
      }
    } catch (error) {
      console.error('获取医生可下发量表列表异常:', error)
      console.error('错误详情:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      })

      if (error.response) {
        // 服务器返回了错误响应
        const status = error.response.status
        const errorData = error.response.data

        if (status === 404) {
          // 接口不存在
          console.warn('量表查询接口不存在，返回空数据')
          return {
            success: true,
            message: '暂无可用量表数据',
            data: [],
            total: 0
          }
        } else if (status === 500) {
          // 服务器内部错误
          console.error('服务器内部错误:', errorData)
          return {
            success: false,
            message: '服务器内部错误，请稍后重试',
            data: [],
            total: 0
          }
        } else {
          const errorMessage = errorData?.message || `服务器错误 (${status})`
          return {
            success: false,
            message: errorMessage,
            errorCode: status,
            data: [],
            total: 0
          }
        }
      } else if (error.request) {
        // 请求发送了但没有收到响应
        return {
          success: false,
          message: '网络连接失败，请检查网络',
          data: [],
          total: 0
        }
      } else {
        // 其他错误
        return {
          success: false,
          message: error.message || '获取量表列表失败，请重试',
          data: [],
          total: 0
        }
      }
    }
  }

  /**
   * 根据类型获取量表列表（旧方法，保持兼容性）
   * 根据接口文档：http://10.105.0.33:20001/scale/get-by-type
   * @param {string} [type='其他'] - 量表类型
   * @returns {Promise<Object>} 量表列表
   */
  async getAvailableScales(type = '其他') {
    try {
      console.log('调用根据类型获取量表列表API:', { type })

      // 检查token
      const token = localStorage.getItem('cbti_token')
      console.log('当前token:', token ? '已设置' : '未设置')

      // 根据接口文档，使用GET请求，type作为query参数
      const response = await apiClient.get('/scale/get-by-type', {
        params: {
          type: type
        }
      })

      // 检查响应数据结构
      const data = response.data
      console.log('获取量表列表API响应详情:', data)
      console.log('响应状态码:', response.status)

      // 根据接口文档，code为0表示成功
      if (data.code === 0) {
        // 确保返回的数据格式符合前端需要
        const scales = data.data || []

        // 转换数据格式，确保包含id和name字段
        const formattedScales = scales.map(scale => ({
          id: scale.id || scale.scaleId,
          name: scale.name || scale.scaleName || scale.title,
          type: scale.type || type,
          description: scale.description || scale.desc,
          ...scale // 保留原始数据
        }))

        return {
          success: true,
          message: data.message || '获取量表列表成功',
          data: formattedScales
        }
      } else {
        // 获取失败
        const errorMessage = data.message || '获取量表列表失败'
        console.warn('获取量表列表失败:', errorMessage)

        return {
          success: false,
          message: errorMessage,
          errorCode: data.code,
          data: []
        }
      }
    } catch (error) {
      console.error('获取量表列表异常:', error)
      console.error('错误详情:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        config: error.config
      })

      if (error.response) {
        // 服务器返回了错误响应
        const status = error.response.status
        const errorData = error.response.data

        let errorMessage = '获取量表列表失败'
        if (errorData?.message) {
          errorMessage = errorData.message
        } else if (status === 401) {
          errorMessage = '未授权访问，请重新登录'
        } else if (status === 404) {
          errorMessage = '量表接口不存在，请检查服务器配置'
        } else if (status === 500) {
          errorMessage = '服务器内部错误，请稍后重试'
        } else {
          errorMessage = `服务器错误 (${status})`
        }

        return {
          success: false,
          message: errorMessage,
          errorCode: status,
          data: []
        }
      } else if (error.request) {
        // 请求发送了但没有收到响应
        return {
          success: false,
          message: '网络连接失败，请检查网络设置',
          data: []
        }
      } else {
        // 其他错误
        return {
          success: false,
          message: error.message || '获取量表列表失败，请重试',
          data: []
        }
      }
    }
  }

  /**
   * 更新量表任务
   * @param {Object} updateData - 更新数据
   * @param {number} updateData.taskId - 任务ID
   * @param {number} updateData.doctorId - 医生ID
   * @param {number} updateData.userId - 患者ID
   * @param {number} updateData.scaleId - 量表ID
   * @param {string} [updateData.deadline] - 任务截止时间（ISO 8601格式）
   * @param {string} [updateData.remark] - 任务备注
   * @returns {Promise<Object>} 更新结果
   */
  async updateScaleTask(updateData) {
    try {
      console.log('调用更新量表任务API:', updateData)

      // 验证必填参数
      if (!updateData.taskId || !updateData.doctorId || !updateData.userId || !updateData.scaleId) {
        return {
          success: false,
          message: '缺少必填参数：taskId、doctorId、userId、scaleId'
        }
      }

      // 构建请求数据，与分配任务接口保持一致的格式
      const requestData = {
        taskId: parseInt(updateData.taskId),
        doctorId: parseInt(updateData.doctorId),
        userId: parseInt(updateData.userId),
        scaleId: parseInt(updateData.scaleId)
      }

      // 添加可选参数
      if (updateData.deadline) {
        requestData.deadline = updateData.deadline
      }
      if (updateData.remark) {
        requestData.remark = updateData.remark
      }

      console.log('发送更新量表任务请求数据:', requestData)

      // 尝试多个可能的更新接口路径
      let response
      let usedEndpoint = ''

      try {
        // 首先尝试标准的更新接口
        console.log('尝试更新接口: /scale/response/task/update')
        response = await apiClient.put('/scale/response/task/update', requestData)
        usedEndpoint = '/scale/response/task/update'
        console.log('使用标准更新接口成功')
      } catch (updateError) {
        console.log('标准更新接口失败，尝试备用接口:', updateError.message)

        try {
          // 备用接口1：使用POST方法的更新接口
          console.log('尝试备用接口1: POST /scale/response/task/update')
          response = await apiClient.post('/scale/response/task/update', requestData)
          usedEndpoint = 'POST /scale/response/task/update'
          console.log('使用备用接口1成功')
        } catch (backup1Error) {
          console.log('备用接口1失败，尝试备用接口2:', backup1Error.message)

          try {
            // 备用接口2：使用任务分配接口进行更新（某些系统中更新和分配使用同一接口）
            console.log('尝试备用接口2: /scale/response/task/assign')
            response = await apiClient.post('/scale/response/task/assign', requestData)
            usedEndpoint = '/scale/response/task/assign'
            console.log('使用备用接口2成功')
          } catch (backup2Error) {
            console.log('备用接口2失败，尝试备用接口3:', backup2Error.message)

            // 备用接口3：使用不同的路径格式
            console.log('尝试备用接口3: /scale/task/update')
            response = await apiClient.put('/scale/task/update', requestData)
            usedEndpoint = '/scale/task/update'
            console.log('使用备用接口3成功')
          }
        }
      }

      // 检查响应数据结构
      const data = response.data
      console.log(`更新量表任务API响应详情 (${usedEndpoint}):`, data)

      // 根据接口文档，code为0表示成功
      if (data.code === 0) {
        return {
          success: true,
          message: data.message || '更新量表任务成功',
          data: data.data || {},
          usedEndpoint
        }
      } else {
        // 更新失败
        const errorMessage = data.message || '更新量表任务失败'
        console.warn('更新量表任务失败:', errorMessage)

        return {
          success: false,
          message: errorMessage,
          errorCode: data.code,
          data: null,
          usedEndpoint
        }
      }
    } catch (error) {
      console.error('更新量表任务异常:', error)

      if (error.response) {
        // 服务器返回了错误响应
        const errorData = error.response.data
        const errorMessage = errorData?.message || `服务器错误 (${error.response.status})`

        return {
          success: false,
          message: errorMessage,
          errorCode: error.response.status
        }
      } else if (error.request) {
        // 请求发送了但没有收到响应
        return {
          success: false,
          message: '网络连接失败，请检查网络'
        }
      } else {
        // 其他错误
        return {
          success: false,
          message: error.message || '更新量表任务失败，请重试'
        }
      }
    }
  }

  /**
   * 软删除量表填写记录
   * 根据接口文档：/scale/response/result/delete
   * @param {number} responseId - 量表记录ID
   * @param {number} operatorId - 医生ID
   * @returns {Promise<Object>} 删除结果
   */
  async deleteScaleTask(responseId, operatorId) {
    try {
      console.log('调用软删除量表填写记录API:', { responseId, operatorId })

      if (!responseId) {
        return {
          success: false,
          message: '量表记录ID不能为空'
        }
      }

      if (!operatorId) {
        return {
          success: false,
          message: '医生ID不能为空'
        }
      }

      // 根据接口文档，使用GET请求，参数通过query传递
      const response = await apiClient.get('/scale/response/result/delete', {
        params: {
          responseId: parseInt(responseId),
          operatorId: parseInt(operatorId)
        }
      })

      // 检查响应数据结构
      const data = response.data
      console.log('软删除量表填写记录API响应详情:', data)
      console.log('响应状态码:', response.status)

      // 根据接口文档，code为0表示成功
      if (data.code === 0) {
        return {
          success: true,
          message: data.message || '量表记录删除成功',
          data: data.data
        }
      } else {
        // 删除失败
        const errorMessage = data.message || '删除量表记录失败'
        console.warn('删除量表记录失败:', errorMessage)
        console.warn('错误代码:', data.code)

        return {
          success: false,
          message: errorMessage,
          errorCode: data.code
        }
      }
    } catch (error) {
      console.error('删除量表任务异常:', error)

      if (error.response) {
        // 服务器返回了错误响应
        const errorData = error.response.data
        const errorMessage = errorData?.message || `服务器错误 (${error.response.status})`

        return {
          success: false,
          message: errorMessage,
          errorCode: error.response.status
        }
      } else if (error.request) {
        // 请求发送了但没有收到响应
        return {
          success: false,
          message: '网络连接失败，请检查网络'
        }
      } else {
        // 其他错误
        return {
          success: false,
          message: error.message || '删除量表任务失败，请重试'
        }
      }
    }
  }

  /**
   * 获取量表评估结果列表（用于评估结果页面）
   * 根据后端接口文档实现
   * @param {Object} [queryParams] - 查询参数
   * @param {string} [queryParams.scale] - 量表类型筛选
   * @param {string} [queryParams.status] - 答题状态筛选
   * @param {string} [queryParams.patientName] - 患者姓名筛选
   * @param {number} [queryParams.page] - 页码
   * @param {number} [queryParams.pageSize] - 每页数量
   * @returns {Promise<Object>} 量表评估结果列表
   */
  async getAssessmentResults(queryParams = {}) {
    try {
      console.log('调用获取量表评估结果列表API:', queryParams)

      // 构建查询参数，根据后端接口文档格式
      const params = {
        page: queryParams.page || 1,
        pageSize: queryParams.pageSize || 10
      }

      // 添加筛选条件（如果有的话）
      if (queryParams.scale) {
        params.scaleName = queryParams.scale
      }
      if (queryParams.status) {
        params.status = queryParams.status
      }
      if (queryParams.patientName) {
        params.patientName = queryParams.patientName
      }

      console.log('构建的请求参数:', params)

      // 调用后端获取量表评估结果列表接口
      // 根据后端接口文档，可能的路径包括：
      // /scale/response/list 或 /scale/result/list 或 /scale/response/results
      const response = await apiClient.get('/scale/response/list', {
        params
      })

      // 检查响应数据结构
      const data = response.data
      console.log('获取量表评估结果列表API响应详情:', data)
      console.log('响应状态码:', response.status)

      // 根据接口文档，code为0表示成功
      if (data.code === 0) {
        // 确保返回的数据格式符合前端需要
        const results = data.data || []
        console.log('原始数据条数:', results.length)

        // 转换数据格式以适配表格显示
        const formattedResults = results.map((result, index) => {
          console.log(`处理第${index + 1}条数据:`, result)

          return {
            id: result.id || result.responseId,
            patientName: result.patientName || result.userName || result.userRealName,
            scaleName: result.scaleName || result.scaleTitle,
            score: result.score || result.totalScore,
            duration: result.duration || result.testDuration || result.completionTime,
            status: ScaleApi.formatStatus(result.status),
            warning: ScaleApi.getWarningLevel(result.score || result.totalScore, result.scaleName || result.scaleTitle),
            updateTime: result.updateTime || result.submitTime || result.completedTime,
            resultId: result.id || result.responseId // 用于查看详情
          }
        })

        console.log('格式化后的数据:', formattedResults)

        return {
          success: true,
          message: data.message || '获取量表评估结果列表成功',
          data: formattedResults,
          total: data.total || data.count || formattedResults.length
        }
      } else {
        // 获取失败
        const errorMessage = data.message || '获取量表评估结果列表失败'
        console.warn('获取量表评估结果列表失败:', errorMessage)

        return {
          success: false,
          message: errorMessage,
          errorCode: data.code,
          data: [],
          total: 0
        }
      }
    } catch (error) {
      console.error('获取量表评估结果列表异常:', error)
      console.error('错误详情:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      })

      if (error.response) {
        // 服务器返回了错误响应
        const status = error.response.status
        const errorData = error.response.data

        if (status === 404) {
          // 接口不存在，返回空数据但不显示错误
          console.warn('量表评估结果接口不存在，返回空数据')
          return {
            success: true,
            message: '暂无评估结果数据',
            data: [],
            total: 0
          }
        } else if (status === 500) {
          // 服务器内部错误
          console.error('服务器内部错误:', errorData)
          return {
            success: true, // 设为true避免显示错误提示
            message: '暂无评估结果数据',
            data: [],
            total: 0
          }
        } else {
          const errorMessage = errorData?.message || `服务器错误 (${status})`
          return {
            success: false,
            message: errorMessage,
            errorCode: status,
            data: [],
            total: 0
          }
        }
      } else if (error.request) {
        // 请求发送了但没有收到响应
        return {
          success: false,
          message: '网络连接失败，请检查网络',
          data: [],
          total: 0
        }
      } else {
        // 其他错误
        return {
          success: false,
          message: error.message || '获取量表评估结果列表失败，请重试',
          data: [],
          total: 0
        }
      }
    }
  }

  /**
   * 格式化状态显示
   * @param {string} status - 原始状态
   * @returns {string} 格式化后的状态
   */
  static formatStatus(status) {
    if (!status) return '未答题'

    const statusMap = {
      completed: '已完成',
      pending: '未答题',
      in_progress: '进行中',
      submitted: '已完成',
      finished: '已完成',
      not_started: '未答题'
    }

    return statusMap[status] || status
  }

  /**
   * 根据分数和量表类型判断预警等级
   * @param {number} score - 分数
   * @param {string} scaleName - 量表名称
   * @returns {string} 预警等级
   */
  static getWarningLevel(score, scaleName) {
    if (!score || score === '') return '未知'

    // 根据不同量表设置不同的预警标准
    const scaleStandards = {
      SDS: { normal: [0, 52], mild: [53, 62], severe: [63, 100] },
      SAS: { normal: [0, 49], mild: [50, 59], severe: [60, 100] },
      PSQI: { normal: [0, 5], mild: [6, 10], severe: [11, 21] },
      EPQ: { normal: [0, 50], mild: [51, 65], severe: [66, 100] },
      DBAS: { normal: [0, 40], mild: [41, 60], severe: [61, 100] }
    }

    // 提取量表类型
    let scaleType = 'default'
    for (const type in scaleStandards) {
      if (scaleName.includes(type)) {
        scaleType = type
        break
      }
    }

    if (scaleType === 'default') {
      return score > 60 ? '异常' : score > 40 ? '轻度' : '正常'
    }

    const standards = scaleStandards[scaleType]
    if (score >= standards.severe[0] && score <= standards.severe[1]) {
      return '异常'
    } else if (score >= standards.mild[0] && score <= standards.mild[1]) {
      return '轻度'
    } else if (score >= standards.normal[0] && score <= standards.normal[1]) {
      return '正常'
    } else {
      return '未知'
    }
  }

  /**
   * 医生给患者下发量表任务
   * @param {Object} taskData - 任务数据
   * @param {number} taskData.doctorId - 医生ID
   * @param {number} taskData.userId - 患者ID
   * @param {number} taskData.scaleId - 量表ID
   * @param {string} [taskData.deadline] - 任务截止时间（ISO 8601格式）
   * @param {string} [taskData.remark] - 任务备注
   * @param {string} taskData.taskPublishTime - 任务发布时间（ISO 8601格式）
   * @returns {Promise<Object>} API响应
   */
  async assignScaleTaskToPatient(taskData) {
    try {
      console.log('下发量表任务，请求参数:', taskData)

      // 验证必需参数
      if (!taskData.doctorId || !taskData.userId || !taskData.scaleId || !taskData.taskPublishTime) {
        throw new Error('缺少必需参数：doctorId, userId, scaleId, taskPublishTime')
      }

      // 构建请求体
      const requestBody = {
        doctorId: parseInt(taskData.doctorId),
        userId: parseInt(taskData.userId),
        scaleId: parseInt(taskData.scaleId),
        taskPublishTime: taskData.taskPublishTime
      }

      // 添加可选参数
      if (taskData.deadline) {
        requestBody.deadline = taskData.deadline
      }
      if (taskData.remark) {
        requestBody.remark = taskData.remark
      }

      console.log('发送请求到 /scale/response/task/assign')
      console.log('请求体:', requestBody)

      // 发送POST请求
      const response = await apiClient.post('/scale/response/task/assign', requestBody)

      console.log('下发量表任务API原始响应:', response)

      const data = response.data || response

      // 根据接口文档，code为0表示成功
      if (data.code === 0) {
        console.log('量表任务下发成功:', data.data)

        return {
          success: true,
          message: data.message || '量表任务下发成功',
          data: data.data
        }
      } else {
        // 下发失败
        const errorMessage = data.message || '量表任务下发失败'
        console.warn('量表任务下发失败:', errorMessage)

        return {
          success: false,
          message: errorMessage,
          errorCode: data.code
        }
      }
    } catch (error) {
      console.error('下发量表任务异常:', error)

      // 检查是否是网络错误
      if (error.code === 'NETWORK_ERROR' || error.message.includes('Network Error')) {
        return {
          success: false,
          message: '网络连接失败，请检查网络后重试'
        }
      }

      // 检查是否是认证错误
      if (error.response?.status === 401) {
        return {
          success: false,
          message: '登录已过期，请重新登录'
        }
      }

      // 其他错误
      return {
        success: false,
        message: error.response?.data?.message || error.message || '量表任务下发失败'
      }
    }
  }

  /**
   * 获取医生可以下发的量表列表
   * @param {Object} [params] - 查询参数
   * @param {number} [params.pageNum=0] - 当前页码（从0开始）
   * @param {number} [params.pageSize=100] - 每页条数
   * @param {Object} [params.queryParams] - 查询条件
   * @param {string} [params.queryParams.status] - 启用状态（启用中/未启用）
   * @returns {Promise<Object>} API响应
   */
  async getAvailableScalesForAssign(params = {}) {
    try {
      console.log('获取可下发量表列表，请求参数:', params)

      // 构建请求体，默认获取启用中的量表
      const requestBody = {
        pageNum: params.pageNum || 0,
        pageSize: params.pageSize || 100, // 获取足够多的量表
        queryParams: {
          status: '启用中', // 只获取启用中的量表
          ...params.queryParams
        }
      }

      console.log('发送请求到 /scale/query-any')
      console.log('请求体:', requestBody)

      // 发送POST请求
      const response = await apiClient.post('/scale/query-any', requestBody)

      console.log('获取可下发量表列表API原始响应:', response)

      const data = response.data || response

      // 根据接口文档，code为0表示成功
      if (data.code === 0) {
        const records = data.data?.records || []
        const total = data.data?.total || 0

        console.log('可下发量表数据条数:', records.length)
        console.log('总记录数:', total)

        // 转换数据格式以适配前端显示，过滤掉无效数据
        const formattedScales = records
          .filter(scale => scale && typeof scale === 'object' && scale.id)
          .map((scale, index) => {
            console.log(`处理第${index + 1}个量表:`, scale)

            return {
              id: scale.id,
              name: scale.name || '',
              code: scale.code || '',
              type: scale.type || '',
              status: scale.status || '',
              description: scale.description || '',
              instruction: scale.instruction || '',
              scoreExplain: scale.scoreExplain || '',
              createTime: scale.createTime || '',
              updateTime: scale.updateTime || '',
              // 保留原始数据
              originalData: scale
            }
          })

        console.log(`格式化量表数据完成，共${formattedScales.length}条记录`)

        return {
          success: true,
          message: data.message || '获取可下发量表列表成功',
          data: formattedScales,
          total: total,
          current: data.data?.current || 0,
          pages: data.data?.pages || 0
        }
      } else {
        // 获取失败
        const errorMessage = data.message || '获取可下发量表列表失败'
        console.warn('获取可下发量表列表失败:', errorMessage)

        return {
          success: false,
          message: errorMessage,
          errorCode: data.code,
          data: [],
          total: 0
        }
      }
    } catch (error) {
      console.error('获取可下发量表列表异常:', error)

      // 检查是否是网络错误
      if (error.code === 'NETWORK_ERROR' || error.message.includes('Network Error')) {
        return {
          success: false,
          message: '网络连接失败，请检查网络后重试',
          data: [],
          total: 0
        }
      }

      // 检查是否是认证错误
      if (error.response?.status === 401) {
        return {
          success: false,
          message: '登录已过期，请重新登录',
          data: [],
          total: 0
        }
      }

      // 其他错误
      return {
        success: false,
        message: error.response?.data?.message || error.message || '获取可下发量表列表失败',
        data: [],
        total: 0
      }
    }
  }

  /**
   * 查询可下发的量表列表（新接口）
   * @param {Object} queryData - 查询参数
   * @param {number} [queryData.pageNum=0] - 当前页码（从0开始）
   * @param {number} [queryData.pageSize=100] - 每页条数
   * @param {Object} [queryData.queryParams] - 查询条件
   * @param {string} [queryData.queryParams.status] - 启用状态（启用中/未启用）
   * @returns {Promise<Object>} 量表列表
   */
  async queryAvailableScales(queryData = {}) {
    try {
      console.log('调用查询可下发量表列表API:', queryData)

      // 默认参数
      const requestData = {
        pageNum: queryData.pageNum || 0,
        pageSize: queryData.pageSize || 100, // 获取更多量表以便选择
        queryParams: {
          status: '启用中', // 只获取启用中的量表
          ...queryData.queryParams
        }
      }

      console.log('发送请求数据:', requestData)

      const response = await apiClient.post('/scale/query-any', requestData)

      console.log('查询量表列表API响应:', response.data)

      if (response.data?.code === 0) {
        const data = response.data.data
        const scales = data?.records || []

        // 转换数据格式以适配前端
        const formattedScales = scales.map(scale => ({
          id: scale.id,
          name: scale.name,
          code: scale.code,
          type: scale.type,
          status: scale.status,
          description: scale.description,
          instruction: scale.instruction,
          scoreExplain: scale.scoreExplain,
          createTime: scale.createTime,
          updateTime: scale.updateTime
        }))

        return {
          success: true,
          message: response.data.message || '获取量表列表成功',
          data: formattedScales,
          total: data?.total || 0,
          pages: data?.pages || 0,
          current: data?.current || 0
        }
      } else {
        return {
          success: false,
          message: response.data?.message || '获取量表列表失败',
          data: [],
          total: 0
        }
      }
    } catch (error) {
      console.error('查询量表列表异常:', error)
      return {
        success: false,
        message: error.response?.data?.message || error.message || '获取量表列表失败，请重试',
        data: [],
        total: 0
      }
    }
  }

  /**
   * 医生查看绑定患者评估结果列表
   * @param {Object} params - 查询参数
   * @param {number} params.current - 当前页码，默认1
   * @param {number} params.size - 每页大小，默认10
   * @param {number} params.patientId - 患者ID
   * @returns {Promise<Object>} 评估结果列表数据
   */
  async getDoctorPatientAssessmentResults(params = {}) {
    try {
      console.log('=== 获取医生绑定患者评估结果列表 ===')
      console.log('请求参数:', params)

      // 验证必填参数
      if (!params.patientId) {
        return {
          success: false,
          message: '患者ID不能为空'
        }
      }

      // 构建查询参数
      const queryParams = {
        current: params.current || 1,
        size: params.size || 10,
        patientId: parseInt(params.patientId)
      }

      // 添加筛选参数支持
      if (params.scaleName) {
        queryParams.scaleName = params.scaleName
      }
      if (params.status) {
        queryParams.status = params.status
      }

      console.log('发送请求到 /scale/response/doctor/tasks')
      console.log('查询参数:', queryParams)

      // 发送GET请求
      const response = await apiClient.get('/scale/response/doctor/tasks', {
        params: queryParams
      })

      console.log('获取评估结果列表API原始响应:', response)

      const data = response.data || response
      if (data.code === 0) {
        console.log('获取评估结果列表成功')
        
        // 先打印原始records，看看里面有什么
        const rawRecords = data.data?.records || []
        console.log('📦 原始records数组长度:', rawRecords.length)
        if (rawRecords.length > 0) {
          console.log('📦 第一条原始记录:', rawRecords[0])
          console.log('📦 第一条记录的ID:', rawRecords[0]?.id)
          console.log('📦 第一条记录的scaleId:', rawRecords[0]?.scaleId)
        }

        // 格式化评估结果数据
        const formattedResults = rawRecords.filter(result => {
          const hasId = result && result.id
          if (!hasId) {
            console.warn('⚠️ 发现无ID的记录，已过滤:', result)
          }
          return hasId
        }).map(result => {
          // 格式化时间
          const formatDateTime = (dateTimeStr) => {
            if (!dateTimeStr) return ''
            try {
              const date = new Date(dateTimeStr)
              return date.toLocaleString('zh-CN', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
              })
            } catch (e) {
              console.error('时间格式化失败:', e, dateTimeStr)
              return dateTimeStr
            }
          }

          // 格式化答题耗时
          const formatSpendTime = (spendTime) => {
            if (!spendTime) return ''
            if (spendTime < 60) {
              return `${spendTime}秒`
            } else {
              const minutes = Math.floor(spendTime / 60)
              const seconds = spendTime % 60
              return `${minutes}分${seconds}秒`
            }
          }

          // 根据分数和量表类型判断预警等级
          const getWarningLevel = (score, scaleName) => {
            if (!score && score !== 0) return '未完成'

            // 根据不同量表设置不同的预警标准
            if (scaleName.includes('抑郁') || scaleName.includes('PHQ')) {
              if (score >= 15) return '重度'
              if (score >= 10) return '中度'
              if (score >= 5) return '轻度'
              return '正常'
            } else if (scaleName.includes('焦虑') || scaleName.includes('HAMA')) {
              if (score >= 29) return '严重焦虑'
              if (score >= 21) return '明显焦虑'
              if (score >= 14) return '肯定焦虑'
              if (score >= 7) return '可能焦虑'
              return '正常'
            } else if (scaleName.includes('睡眠') || scaleName.includes('PSQI')) {
              if (score > 7) return '睡眠质量差'
              return '睡眠质量好'
            } else {
              // 通用标准
              if (score >= 70) return '重度'
              if (score >= 50) return '中度'
              if (score >= 30) return '轻度'
              return '正常'
            }
          }

          return {
            id: result.id || Date.now() + Math.random(), // 确保有ID
            scaleName: result.scaleName || '未知量表',
            scaleId: result.scaleId || result.id,
            userId: result.userId || result.patientId,
            patientId: result.userId || result.patientId, // 兼容字段名
            patientName: result.userName || result.patientName || '未知患者',
            status: result.status || '未完成',
            spendTime: formatSpendTime(result.spendTime), // 格式化答题耗时
            score: result.score, // 量表得分
            resultExplain: result.resultExplain, // 结果解释
            submitTime: formatDateTime(result.submitTime), // 患者提交时间
            taskPublishTime: formatDateTime(result.taskPublishTime), // 医生发布时间
            warning: getWarningLevel(result.score, result.scaleName), // 预警等级
            // 保留原始数据用于详细操作
            originalData: result
          }
        })

        console.log('格式化后的评估结果数据:', formattedResults)

        return {
          success: true,
          message: data.message || '获取评估结果列表成功',
          data: formattedResults,
          total: data.data?.total || 0,
          current: queryParams.current,
          size: queryParams.size
        }
      } else {
        console.error('获取评估结果列表失败:', data)
        return {
          success: false,
          message: data.message || data.msg || '获取评估结果列表失败',
          data: [],
          total: 0
        }
      }
    } catch (error) {
      console.error('获取评估结果列表异常:', error)

      let errorMessage = '获取评估结果列表失败'
      if (error.response) {
        console.error('API响应错误:', error.response)
        const errorData = error.response.data || {}
        errorMessage = errorData.message || errorData.msg || `服务器错误 (${error.response.status})`
      } else if (error.request) {
        console.error('网络请求错误:', error.request)
        errorMessage = '网络连接失败，请检查网络设置'
      } else {
        console.error('请求配置错误:', error.message)
        errorMessage = error.message || '请求失败'
      }

      return {
        success: false,
        message: errorMessage,
        data: [],
        total: 0
      }
    }
  }

  /**
   * 医生查看绑定患者量表任务分页列表
   * @param {Object} params - 查询参数
   * @param {number} params.current - 当前页码，默认1
   * @param {number} params.size - 每页大小，默认10
   * @param {number} [params.patientId] - 患者ID，可选，如果不提供则获取所有患者的任务
   * @returns {Promise<Object>} 任务列表数据
   */
  async getDoctorPatientScaleTasks(params = {}) {
    try {
      console.log('=== 获取医生绑定患者量表任务列表 ===')
      console.log('请求参数:', params)

      // 构建查询参数
      const queryParams = {
        current: params.current || 1,
        size: params.size || 10
      }

      // 如果提供了患者ID，则添加到查询参数中
      if (params.patientId) {
        queryParams.patientId = parseInt(params.patientId)
      }

      console.log('发送请求到 /scale/response/doctor/tasks')
      console.log('查询参数:', queryParams)

      // 发送GET请求
      const response = await apiClient.get('/scale/response/doctor/tasks', {
        params: queryParams
      })

      console.log('获取量表任务列表API原始响应:', response)

      const data = response.data || response
      if (data.code === 0) {
        console.log('获取量表任务列表成功')

        // 格式化时间的辅助函数
        const formatDateTime = (dateTimeStr) => {
          if (!dateTimeStr) return ''
          try {
            const date = new Date(dateTimeStr)
            return date.toLocaleString('zh-CN', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit'
            })
          } catch (e) {
            console.error('时间格式化失败:', e, dateTimeStr)
            return dateTimeStr
          }
        }

        // 格式化任务数据，过滤掉无效数据
        const formattedTasks = (data.data?.records || [])
          .filter(task => {
            // 过滤掉 null 或 undefined 的任务
            if (!task || typeof task !== 'object') {
              console.warn('跳过无效的任务数据:', task)
              return false
            }
            // 确保任务至少有 id
            if (!task.id) {
              console.warn('跳过没有ID的任务数据:', task)
              return false
            }
            return true
          })
          .map(task => {
            console.log('处理量表任务数据:', task)

            return {
              id: task.id,
              scaleName: task.scaleName || '未知量表',
              scaleId: task.scaleId || null,
              userId: task.userId || null, // 保留原始字段名
              patientId: task.userId || null, // 兼容字段名
              patientName: task.userName || '未知患者',
              status: task.status || '未完成',
              spendTime: task.spendTime || null, // 答题耗时（秒）
              score: task.score || null, // 量表得分
              resultExplain: task.resultExplain || '', // 结果解释
              submitTime: formatDateTime(task.submitTime), // 患者提交时间
              taskPublishTime: formatDateTime(task.taskPublishTime), // 医生发布时间
              // 保留原始数据用于详细操作
              originalData: task
            }
          })

        console.log('格式化后的量表任务数据:', formattedTasks)

        return {
          success: true,
          message: data.message || '获取量表任务列表成功',
          data: formattedTasks,
          total: data.data?.total || 0,
          current: queryParams.current,
          size: queryParams.size
        }
      } else {
        console.error('获取量表任务列表失败:', data)
        return {
          success: false,
          message: data.message || data.msg || '获取量表任务列表失败',
          data: [],
          total: 0
        }
      }
    } catch (error) {
      console.error('获取量表任务列表异常:', error)

      let errorMessage = '获取量表任务列表失败'
      if (error.response) {
        console.error('API响应错误:', error.response)
        const errorData = error.response.data || {}
        errorMessage = errorData.message || errorData.msg || `服务器错误 (${error.response.status})`
      } else if (error.request) {
        console.error('网络请求错误:', error.request)
        errorMessage = '网络连接失败，请检查网络设置'
      } else {
        console.error('请求配置错误:', error.message)
        errorMessage = error.message || '请求失败'
      }

      return {
        success: false,
        message: errorMessage,
        data: [],
        total: 0
      }
    }
  }

  /**
   * 查询量表填写记录详情
   * @param {number} recordId - 量表记录ID
   * @returns {Promise<Object>} 量表填写详情
   */
  async getScaleResponseDetail(recordId) {
    try {
      console.log('=== 查询量表填写记录详情 ===')
      console.log('记录ID:', recordId)

      if (!recordId) {
        console.error('记录ID不能为空')
        return {
          success: false,
          message: '记录ID不能为空',
          data: null
        }
      }

      console.log('发送请求到 /scale/response/result/' + recordId)

      // 尝试多个可能的API端点
      let response
      let usedEndpoint = ''

      try {
        // 首先尝试主要端点
        console.log('尝试主要端点: /scale/response/result/' + recordId)
        response = await apiClient.get(`/scale/response/result/${recordId}`)
        usedEndpoint = '/scale/response/result/' + recordId
        console.log('主要端点调用成功')
      } catch (primaryError) {
        console.log('主要端点失败，尝试备用端点:', primaryError.message)

        try {
          // 备用端点1: 使用不同的路径格式
          console.log('尝试备用端点1: /scale/result/' + recordId)
          response = await apiClient.get(`/scale/result/${recordId}`)
          usedEndpoint = '/scale/result/' + recordId
          console.log('备用端点1调用成功')
        } catch (backup1Error) {
          console.log('备用端点1失败，尝试备用端点2:', backup1Error.message)

          try {
            // 备用端点2: 使用查询参数格式
            console.log('尝试备用端点2: /scale/response/detail')
            response = await apiClient.get('/scale/response/detail', {
              params: { id: recordId }
            })
            usedEndpoint = '/scale/response/detail?id=' + recordId
            console.log('备用端点2调用成功')
          } catch (backup2Error) {
            console.log('所有备用端点都失败，抛出原始错误')
            throw primaryError // 抛出原始错误
          }
        }
      }

      console.log('使用的API端点:', usedEndpoint)

      console.log('查询量表填写记录详情API原始响应:', response)

      const data = response.data || response
      if (data.code === 0) {
        console.log('查询量表填写记录详情成功')

        // 检查是否有数据
        if (!data.data) {
          console.warn('API返回成功但数据为空')
          return {
            success: false,
            message: '量表记录不存在或已被删除',
            data: null
          }
        }

        // 格式化时间
        const formatDateTime = (dateTimeStr) => {
          if (!dateTimeStr) return ''
          try {
            const date = new Date(dateTimeStr)
            return date.toLocaleString('zh-CN', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit'
            })
          } catch (e) {
            console.error('时间格式化失败:', e, dateTimeStr)
            return dateTimeStr
          }
        }

        // 在格式化数据前，先检查原始API数据结构
        console.log('🔍 原始API返回的量表详情数据:', data.data)
        if (data.data.questionResults && data.data.questionResults.length > 0) {
          console.log('📋 原始题目数据示例 (前3题):')
          data.data.questionResults.slice(0, 3).forEach((q, idx) => {
            console.log(`第${idx + 1}题 - 所有字段:`, q)
            console.log(`第${idx + 1}题 - 字段列表:`, Object.keys(q))
          })
        }

        // 格式化返回数据
        const formattedData = {
          id: data.data.id,
          scaleName: data.data.scaleName || '未知量表',
          score: data.data.score,
          resultExplain: data.data.resultExplain || '',
          submitTime: formatDateTime(data.data.submitTime),
          questionResults: (data.data.questionResults || []).map((question, qIndex) => {
            // 详细记录每个题目的原始数据
            console.log(`🔍 题目${qIndex + 1}原始数据:`, question)

            // 尝试从多个可能的字段获取用户答案
            let userAnswer = ''

            // 检查所有可能包含用户答案的字段
            const answerFields = [
              'userAnswer', 'answer', 'selectedAnswer', 'response', 'userResponse',
              'selectedOption', 'choice', 'value', 'selectedValue', 'answerText',
              'optionText', 'chosenOption', 'answerIndex', 'optionIndex'
            ]

            for (const field of answerFields) {
              if (question[field] !== undefined && question[field] !== null &&
                  question[field] !== '' && question[field] !== '无效选项') {
                userAnswer = question[field]
                console.log(`✅ 在字段 ${field} 中找到有效答案:`, userAnswer)
                break
              }
            }

            // 如果所有字段都是无效的，记录警告并尝试从其他地方获取
            if (!userAnswer || userAnswer === '无效选项') {
              console.warn(`⚠️ 题目${qIndex + 1}无法找到有效答案，所有检查的字段:`,
                answerFields.reduce((obj, field) => {
                  obj[field] = question[field]
                  return obj
                }, {}))

              // 最后的备选方案：如果有选项信息，尝试从选项中推断
              if (question.options && Array.isArray(question.options)) {
                console.log(`🔍 题目${qIndex + 1}的选项信息:`, question.options)
                // 可以在这里添加更复杂的逻辑来从选项中推断用户选择
              }

              userAnswer = question.userAnswer || '未作答'
            }

            return {
              questionContent: question.questionContent || '',
              questionType: question.questionType || '',
              userAnswer: userAnswer,
              score: question.score || 0,
              // 保留原始数据用于调试
              _originalData: question
            }
          })
        }

        console.log('格式化后的量表详情数据:', formattedData)

        return {
          success: true,
          message: data.message || '查询量表填写记录详情成功',
          data: formattedData
        }
      } else {
        console.error('查询量表填写记录详情失败:', data)

        // 根据错误代码提供更友好的错误信息
        let errorMessage = data.message || data.msg || '查询量表填写记录详情失败'

        if (data.code === 404 || errorMessage.includes('不存在')) {
          errorMessage = '量表记录不存在或已被删除'
        } else if (data.code === 401 || errorMessage.includes('未授权')) {
          errorMessage = '登录已过期，请重新登录'
        } else if (data.code === 500 || errorMessage.includes('服务器')) {
          errorMessage = '服务器繁忙，请稍后重试'
        }

        return {
          success: false,
          message: errorMessage,
          data: null
        }
      }
    } catch (error) {
      console.error('查询量表填写记录详情异常:', error)

      let errorMessage = '查询量表填写记录详情失败'

      if (error.response) {
        console.error('API响应错误:', error.response)
        const status = error.response.status
        const errorData = error.response.data || {}

        if (status === 500) {
          errorMessage = '服务器繁忙，请稍后重试'
        } else if (status === 404) {
          errorMessage = '量表记录不存在或已被删除'
        } else if (status === 401) {
          errorMessage = '登录已过期，请重新登录'
        } else if (status === 403) {
          errorMessage = '没有权限访问该记录'
        } else {
          errorMessage = errorData.message || errorData.msg || `服务器错误 (${status})`
        }
      } else if (error.request) {
        console.error('网络请求错误:', error.request)
        errorMessage = '网络连接失败，请检查网络设置'
      } else {
        console.error('请求配置错误:', error.message)
        errorMessage = error.message || '请求失败'
      }

      return {
        success: false,
        message: errorMessage,
        data: null
      }
    }
  }

  /**
   * 软删除量表填写记录
   * @param {number} responseId - 量表记录ID
   * @param {number} operatorId - 医生ID
   * @returns {Promise<Object>} 删除结果
   */
  async deleteScaleResponse(responseId, operatorId) {
    try {
      console.log('=== 软删除量表填写记录 ===')
      console.log('记录ID:', responseId)
      console.log('操作者ID:', operatorId)

      if (!responseId) {
        console.error('记录ID不能为空')
        return {
          success: false,
          message: '记录ID不能为空',
          data: null
        }
      }

      if (!operatorId) {
        console.error('操作者ID不能为空')
        return {
          success: false,
          message: '操作者ID不能为空',
          data: null
        }
      }

      console.log('发送请求到 /scale/response/result/delete')
      console.log('查询参数:', { responseId, operatorId })

      // 发送GET请求，参数作为查询参数
      const response = await apiClient.get('/scale/response/result/delete', {
        params: {
          responseId: parseInt(responseId),
          operatorId: parseInt(operatorId)
        }
      })

      console.log('软删除量表填写记录API原始响应:', response)

      const data = response.data || response
      if (data.code === 0) {
        console.log('软删除量表填写记录成功')

        return {
          success: true,
          message: data.message || '删除量表记录成功',
          data: data.data
        }
      } else {
        console.error('软删除量表填写记录失败:', data)
        return {
          success: false,
          message: data.message || data.msg || '删除量表记录失败',
          data: null
        }
      }
    } catch (error) {
      console.error('软删除量表填写记录异常:', error)

      let errorMessage = '删除量表记录失败'
      if (error.response) {
        console.error('API响应错误:', error.response)
        const errorData = error.response.data || {}
        errorMessage = errorData.message || errorData.msg || `服务器错误 (${error.response.status})`
      } else if (error.request) {
        console.error('网络请求错误:', error.request)
        errorMessage = '网络连接失败，请检查网络设置'
      } else {
        console.error('请求配置错误:', error.message)
        errorMessage = error.message || '请求失败'
      }

      return {
        success: false,
        message: errorMessage,
        data: null
      }
    }
  }

  /**
   * 查看绑定的患者所有评估量表
   * @param {Object} params - 查询参数
   * @param {number} params.current - 当前页码，默认1
   * @param {number} params.size - 每页大小，默认10
   * @returns {Promise<Object>} 评估量表列表数据
   */
  async getDoctorPatientAssessmentRecords(params = {}) {
    try {
      console.log('=== 获取医生绑定患者评估量表列表 ===')
      console.log('请求参数:', params)

      // 构建查询参数
      const queryParams = {
        current: params.current || 1,
        size: params.size || 10
      }

      console.log('发送请求到 /scale/doctor/patient-assessmentRecords')
      console.log('查询参数:', queryParams)

      // 发送GET请求
      const response = await apiClient.get('/scale/doctor/patient-assessmentRecords', {
        params: queryParams
      })

      console.log('获取评估量表列表API原始响应:', response)

      const data = response.data || response
      if (data.code === 0) {
        console.log('获取评估量表列表成功')

        // 格式化时间的辅助函数
        const formatDateTime = (dateTimeStr) => {
          if (!dateTimeStr) return ''
          try {
            const date = new Date(dateTimeStr)
            return date.toLocaleString('zh-CN', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit'
            })
          } catch (e) {
            console.error('时间格式化失败:', e, dateTimeStr)
            return dateTimeStr
          }
        }

        // 格式化评估结果预警等级
        const formatReportWarning = (warning) => {
          if (!warning) return ''
          return warning
        }

        // 格式化评估量表数据，过滤掉无效数据
        const formattedRecords = (data.data?.records || [])
          .filter(record => record && typeof record === 'object' && record.id)
          .map(record => {
            console.log('处理评估量表记录数据:', record)

          return {
            id: record.id,
            patientName: record.patientName || '未知患者',
            scaleName: record.scaleName || '未知量表',
            totalScore: record.totalScore,
            testTime: formatDateTime(record.testTime),
            answerStatus: record.answerStatus || '未完成',
            reportWarning: formatReportWarning(record.reportWarning),
            updateTime: formatDateTime(record.updateTime),
            // 保留原始数据用于详细操作
            originalData: record
          }
        })

        console.log('格式化后的评估量表数据:', formattedRecords)

        return {
          success: true,
          message: data.message || '获取评估量表列表成功',
          data: formattedRecords,
          total: data.data?.total || 0,
          current: data.data?.current || 1,
          size: data.data?.size || 10,
          pages: data.data?.pages || 1
        }
      } else {
        console.error('获取评估量表列表失败:', data)
        return {
          success: false,
          message: data.message || data.msg || '获取评估量表列表失败',
          data: [],
          total: 0
        }
      }
    } catch (error) {
      console.error('获取评估量表列表异常:', error)

      let errorMessage = '获取评估量表列表失败'
      if (error.response) {
        console.error('API响应错误:', error.response)
        const errorData = error.response.data || {}
        errorMessage = errorData.message || errorData.msg || `服务器错误 (${error.response.status})`
      } else if (error.request) {
        console.error('网络请求错误:', error.request)
        errorMessage = '网络连接失败，请检查网络设置'
      } else {
        console.error('请求配置错误:', error.message)
        errorMessage = error.message || '请求失败'
      }

      return {
        success: false,
        message: errorMessage,
        data: [],
        total: 0
      }
    }
  }

  /**
   * 导出患者评估结果
   * @param {Array<string>} patientIds - 选中的患者的评估结果ID数组
   * @returns {Promise<Object>} 导出结果
   */
  async exportPatientAssessmentResults(patientIds) {
    try {
      console.log('调用导出患者评估结果API:', patientIds)

      if (!patientIds || patientIds.length === 0) {
        return {
          success: false,
          message: '请选择要导出的患者评估结果'
        }
      }

      // 调用导出接口
      const response = await apiClient.post('/scale/export/patients', null, {
        params: {
          patientIds: patientIds
        },
        responseType: 'blob' // 重要：设置响应类型为blob以处理文件下载
      })

      console.log('导出患者评估结果API响应:', response)

      // 检查响应是否为blob类型
      if (response.data instanceof Blob) {
        return {
          success: true,
          data: response.data,
          message: '导出成功'
        }
      } else {
        return {
          success: false,
          message: '导出失败：返回数据格式错误'
        }
      }
    } catch (error) {
      console.error('导出患者评估结果异常:', error)

      // 如果是网络错误或服务器错误
      if (error.response) {
        const status = error.response.status
        if (status === 404) {
          return {
            success: false,
            message: '导出接口不存在，请联系管理员'
          }
        } else if (status === 500) {
          return {
            success: false,
            message: '服务器内部错误，请稍后重试'
          }
        } else {
          return {
            success: false,
            message: `导出失败：HTTP ${status}`
          }
        }
      }

      return {
        success: false,
        message: '导出失败，请检查网络连接后重试'
      }
    }
  }

  /**
   * 根据量表结果ID导出量表结果（批量）
   * @param {Array<string>} responseIds - 量表结果ID数组
   * @returns {Promise<Object>} 导出结果（压缩包）
   */
  async exportScaleResults(responseIds) {
    try {
      console.log('调用批量导出量表结果API:', responseIds)

      if (!responseIds || responseIds.length === 0) {
        return {
          success: false,
          message: '请提供有效的量表结果ID'
        }
      }

      // 构建查询参数
      const queryParams = new URLSearchParams()
      responseIds.forEach(id => {
        queryParams.append('responseIds', id)
      })

      console.log('导出量表结果查询参数:', queryParams.toString())

      // 发送GET请求到导出接口（按用户提供的接口文档）
      const response = await apiClient.get(`/doctor/profile/info?${queryParams.toString()}`, {
        responseType: 'blob', // 重要：设置响应类型为blob以处理文件下载
        headers: {
          Accept: 'application/zip, application/octet-stream, */*'
        }
      })

      console.log('导出量表结果API响应:', response)
      console.log('响应状态:', response.status)
      console.log('响应头:', response.headers)
      console.log('响应数据类型:', typeof response.data)
      console.log('是否为Blob:', response.data instanceof Blob)

      // 检查响应
      if (response && response.data) {
        // 检查是否为blob类型
        if (response.data instanceof Blob) {
          console.log('压缩包大小:', response.data.size, 'bytes')
          console.log('压缩包类型:', response.data.type)

          // 检查文件大小
          if (response.data.size === 0) {
            return {
              success: false,
              message: '导出的文件为空'
            }
          }

          return {
            success: true,
            data: response.data,
            message: '导出成功'
          }
        } else {
          console.error('响应数据不是Blob类型:', response.data)
          return {
            success: false,
            message: '导出失败：返回数据格式错误'
          }
        }
      } else {
        console.error('响应为空或无数据')
        return {
          success: false,
          message: '导出失败：响应数据为空'
        }
      }
    } catch (error) {
      console.error('导出量表结果失败:', error)

      // 详细的错误信息记录
      let errorMessage = '导出失败，请重试'

      if (error.response) {
        console.error('响应错误:', {
          status: error.response.status,
          statusText: error.response.statusText,
          data: error.response.data,
          headers: error.response.headers
        })

        // 如果响应是blob但状态码不是200，可能是错误信息
        if (error.response.data instanceof Blob && error.response.status !== 200) {
          try {
            const text = await error.response.data.text()
            console.error('Blob错误内容:', text)
            try {
              const errorData = JSON.parse(text)
              errorMessage = errorData.message || errorData.msg || errorMessage
            } catch (parseError) {
              // 如果不是JSON格式，直接使用文本内容
              errorMessage = text || errorMessage
            }
          } catch (blobError) {
            console.error('解析Blob错误内容失败:', blobError)
          }
        } else if (error.response.data && typeof error.response.data === 'object') {
          errorMessage = error.response.data.message || error.response.data.msg || errorMessage
        }

        // 根据状态码提供更具体的错误信息
        if (error.response.status === 401) {
          errorMessage = '认证失败，请重新登录'
        } else if (error.response.status === 403) {
          errorMessage = '权限不足，无法导出量表结果'
        } else if (error.response.status === 404) {
          errorMessage = '导出接口不存在，请联系管理员'
        } else if (error.response.status === 500) {
          errorMessage = '服务器内部错误，请稍后重试'
        }
      } else if (error.request) {
        console.error('请求错误:', error.request)
        errorMessage = '网络连接失败，请检查网络设置'
      } else {
        console.error('其他错误:', error.message)
        errorMessage = error.message || errorMessage
      }

      return {
        success: false,
        message: errorMessage,
        error: error
      }
    }
  }

  /**
   * 导出单个量表评估报告
   * @param {string} recordId - 量表评估记录ID
   * @returns {Promise<Object>} 导出结果
   */
  async exportScaleReport(recordId) {
    try {
      console.log('调用导出单个量表评估报告API:', recordId)

      if (!recordId) {
        return {
          success: false,
          message: '请提供有效的记录ID'
        }
      }

      // 发送GET请求到导出接口
      const response = await apiClient.get(`/scale/export/report/${recordId}`, {
        responseType: 'blob', // 重要：设置响应类型为blob以处理文件下载
        headers: {
          Accept: 'application/pdf'
        }
      })

      console.log('导出单个量表评估报告响应:', response)

      // 检查响应
      if (response && response.data) {
        // 检查是否为blob类型
        if (response.data instanceof Blob) {
          console.log('PDF Blob大小:', response.data.size, 'bytes')
          console.log('PDF Blob类型:', response.data.type)

          return {
            success: true,
            data: response.data,
            message: '导出成功'
          }
        } else {
          console.error('响应数据不是Blob类型:', typeof response.data)
          return {
            success: false,
            message: '导出失败：响应格式错误'
          }
        }
      } else {
        console.error('导出单个量表评估报告失败: 无响应数据')
        return {
          success: false,
          message: '导出失败：无响应数据'
        }
      }
    } catch (error) {
      console.error('导出单个量表评估报告异常:', error)

      // 处理不同类型的错误
      if (error.response) {
        const status = error.response.status
        const statusText = error.response.statusText
        console.error('HTTP错误:', status, statusText)

        if (status === 404) {
          return {
            success: false,
            message: '评估记录不存在'
          }
        } else if (status === 403) {
          return {
            success: false,
            message: '没有权限导出该报告'
          }
        } else {
          return {
            success: false,
            message: `导出失败 (${status}): ${statusText}`
          }
        }
      } else if (error.request) {
        console.error('网络错误:', error.request)
        return {
          success: false,
          message: '网络连接失败，请检查网络后重试'
        }
      } else {
        console.error('其他错误:', error.message)
        return {
          success: false,
          message: error.message || '导出失败，请重试'
        }
      }
    }
  }

  /**
   * 导出量表评估结果
   * @param {Array<string>} scaleIds - 量表评估结果的id们
   * @returns {Promise<Object>} 导出结果
   */
  async exportScaleAssessmentResults(scaleIds) {
    try {
      console.log('调用导出量表评估结果API:', scaleIds)

      if (!scaleIds || scaleIds.length === 0) {
        return {
          success: false,
          message: '请选择要导出的量表评估结果'
        }
      }

      // 构建请求参数 - 后端期望逗号分隔的字符串格式
      const params = {
        scaleIds: scaleIds.join(',')
      }

      console.log('导出量表评估结果请求参数:', params)

      // 发送POST请求到导出接口
      const response = await apiClient.post('/scale/export/scales', null, {
        params,
        responseType: 'blob', // 重要：设置响应类型为blob以处理文件下载
        headers: {
          Accept: 'application/zip'
        }
      })

      console.log('导出量表评估结果响应:', response)
      console.log('响应状态:', response.status)
      console.log('响应头:', response.headers)
      console.log('响应数据类型:', typeof response.data)
      console.log('是否为Blob:', response.data instanceof Blob)

      // 检查响应
      if (response && response.data) {
        // 检查是否为blob类型
        if (response.data instanceof Blob) {
          console.log('Blob大小:', response.data.size, 'bytes')
          console.log('Blob类型:', response.data.type)

          return {
            success: true,
            data: response.data,
            message: '导出成功'
          }
        } else {
          console.error('响应数据不是Blob类型:', response.data)
          return {
            success: false,
            message: '导出失败：返回数据格式错误'
          }
        }
      } else {
        console.error('响应为空或无数据')
        return {
          success: false,
          message: '导出失败：服务器响应异常'
        }
      }
    } catch (error) {
      console.error('导出量表评估结果失败:', error)

      // 处理不同类型的错误
      if (error.response) {
        const status = error.response.status
        const statusText = error.response.statusText

        if (status === 401) {
          return {
            success: false,
            message: '登录已过期，请重新登录'
          }
        } else if (status === 403) {
          return {
            success: false,
            message: '没有权限执行此操作'
          }
        } else if (status === 404) {
          return {
            success: false,
            message: '导出接口不存在'
          }
        } else if (status >= 500) {
          return {
            success: false,
            message: '服务器内部错误，请稍后重试'
          }
        } else {
          return {
            success: false,
            message: `导出失败：${status} ${statusText}`
          }
        }
      } else if (error.request) {
        return {
          success: false,
          message: '网络连接失败，请检查网络设置'
        }
      } else {
        return {
          success: false,
          message: error.message || '导出失败，请重试'
        }
      }
    }
  }

  /**
   * 患者信息动态搜索
   * @param {Object} searchParams - 搜索参数
   * @returns {Promise<Object>} 搜索结果
   */
  async searchPatients(searchParams = {}) {
    try {
      console.log('调用患者信息动态搜索API:', searchParams)

      // 构建请求体，过滤掉空值
      const requestBody = {}

      // 分页参数
      requestBody.current = searchParams.current || 1
      requestBody.size = searchParams.size || 10

      // 基础搜索字段
      if (searchParams.name) requestBody.name = searchParams.name
      if (searchParams.phone) requestBody.phone = searchParams.phone
      if (searchParams.patientNo) requestBody.patientNo = searchParams.patientNo

      // 基本信息字段
      if (searchParams.gender !== undefined && searchParams.gender !== null) {
        requestBody.gender = parseInt(searchParams.gender)
      }
      if (searchParams.ageMin !== undefined && searchParams.ageMin !== null) {
        requestBody.ageMin = parseInt(searchParams.ageMin)
      }
      if (searchParams.ageMax !== undefined && searchParams.ageMax !== null) {
        requestBody.ageMax = parseInt(searchParams.ageMax)
      }

      // 身体指标字段
      if (searchParams.heightMin !== undefined && searchParams.heightMin !== null) {
        requestBody.heightMin = parseFloat(searchParams.heightMin)
      }
      if (searchParams.heightMax !== undefined && searchParams.heightMax !== null) {
        requestBody.heightMax = parseFloat(searchParams.heightMax)
      }
      if (searchParams.weightMin !== undefined && searchParams.weightMin !== null) {
        requestBody.weightMin = parseFloat(searchParams.weightMin)
      }
      if (searchParams.weightMax !== undefined && searchParams.weightMax !== null) {
        requestBody.weightMax = parseFloat(searchParams.weightMax)
      }

      // 社会信息字段
      if (searchParams.education) requestBody.education = searchParams.education
      if (searchParams.profession) requestBody.profession = searchParams.profession
      if (searchParams.isMarried !== undefined && searchParams.isMarried !== null) {
        requestBody.isMarried = parseInt(searchParams.isMarried)
      }
      if (searchParams.nation) requestBody.nation = searchParams.nation

      // 医疗信息字段
      if (searchParams.complaint) requestBody.complaint = searchParams.complaint
      if (searchParams.clinicalDiagnosis) requestBody.clinicalDiagnosis = searchParams.clinicalDiagnosis
      if (searchParams.state) requestBody.state = searchParams.state

      // 时间字段
      if (searchParams.wakeUpTimeStart) requestBody.wakeUpTimeStart = searchParams.wakeUpTimeStart
      if (searchParams.wakeUpTimeEnd) requestBody.wakeUpTimeEnd = searchParams.wakeUpTimeEnd
      if (searchParams.uploadTimeStart) requestBody.uploadTimeStart = searchParams.uploadTimeStart
      if (searchParams.uploadTimeEnd) requestBody.uploadTimeEnd = searchParams.uploadTimeEnd

      console.log('构建的搜索请求体:', requestBody)

      // 发送POST请求
      const response = await apiClient.post('/doctor/patient/search', requestBody)

      console.log('患者搜索API响应:', response)

      const data = response.data
      if (data.code === 0) {
        const result = data.data || {}
        const patients = result.records || []

        console.log('搜索到的患者数量:', patients.length)

        return {
          success: true,
          message: data.message || '搜索成功',
          data: patients,
          total: result.total || 0,
          current: result.current || 1,
          size: result.size || 10,
          pages: result.pages || 1
        }
      } else {
        console.warn('患者搜索失败:', data.message)
        return {
          success: false,
          message: data.message || '搜索失败',
          data: [],
          total: 0
        }
      }
    } catch (error) {
      console.error('患者搜索异常:', error)

      // 处理不同类型的错误
      if (error.response) {
        const status = error.response.status
        if (status === 401) {
          return {
            success: false,
            message: '登录已过期，请重新登录'
          }
        } else if (status === 403) {
          return {
            success: false,
            message: '没有权限执行此操作'
          }
        } else {
          return {
            success: false,
            message: `搜索失败：${error.response.statusText}`
          }
        }
      } else {
        return {
          success: false,
          message: error.message || '搜索失败，请重试'
        }
      }
    }
  }

  /**
   * 批量导出患者信息
   * @param {Array<number>} patientIds - 患者ID数组，为空数组或不传则导出所有患者信息
   * @returns {Promise<Object>} 导出结果
   */
  async exportPatientList(patientIds = []) {
    try {
      console.log('调用批量导出患者信息API:', patientIds)

      // 构建请求体
      const requestBody = {
        patientIds: patientIds
      }

      console.log('导出患者信息请求体:', requestBody)

      // 发送POST请求
      const response = await apiClient.post('/user/export/exportPatientList', requestBody, {
        responseType: 'blob', // 重要：设置响应类型为blob以处理文件下载
        headers: {
          Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      })

      console.log('导出患者信息API响应:', response)

      // 检查响应
      if (response && response.data) {
        // 检查是否为blob类型
        if (response.data instanceof Blob) {
          console.log('Blob大小:', response.data.size, 'bytes')

          return {
            success: true,
            data: response.data,
            message: '导出成功'
          }
        } else {
          console.error('响应数据不是Blob类型:', response.data)
          return {
            success: false,
            message: '导出失败：返回数据格式错误'
          }
        }
      } else {
        console.error('响应为空或无数据')
        return {
          success: false,
          message: '导出失败：响应数据为空'
        }
      }
    } catch (error) {
      console.error('导出患者信息失败:', error)

      // 处理不同类型的错误
      if (error.response) {
        const status = error.response.status
        if (status === 401) {
          return {
            success: false,
            message: '登录已过期，请重新登录'
          }
        } else if (status === 403) {
          return {
            success: false,
            message: '没有权限执行此操作'
          }
        } else if (status === 404) {
          return {
            success: false,
            message: '导出接口不存在'
          }
        } else if (status >= 500) {
          return {
            success: false,
            message: '服务器内部错误，请稍后重试'
          }
        } else {
          return {
            success: false,
            message: `导出失败：${status} ${error.response.statusText}`
          }
        }
      } else if (error.request) {
        return {
          success: false,
          message: '网络连接失败，请检查网络设置'
        }
      } else {
        return {
          success: false,
          message: error.message || '导出失败，请重试'
        }
      }
    }
  }

  /**
   * 更新量表任务记录
   * 支持多个API端点，自动尝试最适合的接口
   * @param {Object} updateData - 更新数据
   * @param {number} updateData.id - 记录唯一 ID
   * @param {number} updateData.userId - 患者 ID
   * @param {number} updateData.doctorId - 关联医生 ID
   * @param {number} updateData.scaleId - 所用量表 ID
   * @param {string} updateData.status - 填写状态：已完成 / 未完成
   * @param {number|null} updateData.spendTime - 答题耗时（秒）
   * @param {string} updateData.fillRecord - 题号-答案映射 JSON 字符串
   * @param {number} updateData.score - 量表总分
   * @param {string} updateData.resultExplain - 结果解释
   * @param {string|null} updateData.resultWarning - 预警提示
   * @param {number} updateData.isScaleTask - 是否为任务：0-否，1-是
   * @param {string|null} updateData.remark - 医生备注
   * @param {string|null} updateData.taskPublishTime - 任务发布时间
   * @param {string} updateData.submitTime - 提交时间
   * @param {string|null} updateData.deadline - 截止日期
   * @param {number} updateData.deleted - 逻辑删除：0-正常，1-已删除
   * @param {string} updateData.createTime - 创建时间
   * @param {string} updateData.updateTime - 更新时间
   * @returns {Promise<Object>} 更新结果
   */
  async updateScaleTaskRecord(updateData) {
    try {
      console.log('=== 🏥 更新量表任务记录 ===')
      console.log('📥 接收到的更新数据:', updateData)

      // 验证必填参数
      if (!updateData.id || !updateData.userId || !updateData.doctorId || !updateData.scaleId) {
        return {
          success: false,
          message: '缺少必填参数：id、userId、doctorId、scaleId'
        }
      }

      // 🔍 数据诊断信息
      console.log('📊 关键参数验证:')
      console.log(`- 任务ID: ${updateData.id} (${typeof updateData.id})`)
      console.log(`- 患者ID: ${updateData.userId} (${typeof updateData.userId})`)
      console.log(`- 医生ID: ${updateData.doctorId} (${typeof updateData.doctorId})`)
      console.log(`- 量表ID: ${updateData.scaleId} (${typeof updateData.scaleId})`)
      console.log(`- 状态: ${updateData.status}`)

      // 🩺 专门检查医生患者绑定关系可能的问题
      console.log('🔍 医患关系检查:')
      console.log(`- 医生ID ${updateData.doctorId} 和 患者ID ${updateData.userId} 的绑定关系`)
      console.log('- 如果您确定已经绑定，但仍然出现500错误，可能是:')
      console.log('  1. 后端验证逻辑更严格')
      console.log('  2. 绑定关系表中的数据状态问题')
      console.log('  3. 权限验证的额外要求')
      console.log('  4. 数据库连接或查询问题')

      // 🧪 尝试验证医生患者绑定关系
      const validateDoctorPatientBinding = async(doctorId, patientId) => {
        try {
          console.log(`🔗 验证绑定关系: 医生${doctorId} ↔ 患者${patientId}`)

          // 尝试调用患者列表API来验证绑定关系
          const testResponse = await apiClient.get('/patient/list', {
            params: { current: 1, size: 1 }
          })

          if (testResponse.data.code === 0) {
            console.log('✅ API调用成功，医生身份验证通过')
            return true
          } else {
            console.log('❌ API调用失败，可能存在身份验证问题')
            return false
          }
        } catch (error) {
          console.log('❌ 绑定关系验证失败:', error.message)
          return false
        }
      }

      // 执行绑定关系验证
      console.log('🔄 开始验证医患绑定关系...')
      const bindingValid = await validateDoctorPatientBinding(updateData.doctorId, updateData.userId)
      console.log(`🔍 绑定关系验证结果: ${bindingValid ? '✅ 通过' : '❌ 失败'}`)

      // 时间格式化函数
      const formatDateTime = (dateTime) => {
        if (!dateTime) return null
        try {
          const date = new Date(dateTime)
          if (isNaN(date.getTime())) return null

          // 使用中国时区的标准格式：YYYY-MM-DD HH:mm:ss
          const year = date.getFullYear()
          const month = String(date.getMonth() + 1).padStart(2, '0')
          const day = String(date.getDate()).padStart(2, '0')
          const hours = String(date.getHours()).padStart(2, '0')
          const minutes = String(date.getMinutes()).padStart(2, '0')
          const seconds = String(date.getSeconds()).padStart(2, '0')

          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        } catch (error) {
          console.warn('时间格式化失败:', error, dateTime)
          return null
        }
      }

      // 构建请求数据，首先尝试最小字段集合
      const baseRequestData = {
        id: parseInt(updateData.id),
        userId: parseInt(updateData.userId),
        doctorId: parseInt(updateData.doctorId),
        scaleId: parseInt(updateData.scaleId),
        status: updateData.status || '未完成'
      }

      // 添加可选字段，只有非空/非null值才添加
      const optionalFields = {
        spendTime: updateData.spendTime ? parseInt(updateData.spendTime) : undefined,
        fillRecord: updateData.fillRecord || undefined,
        score: updateData.score !== undefined && updateData.score !== null && updateData.score !== '' ? parseInt(updateData.score) : undefined,
        resultExplain: updateData.resultExplain || undefined,
        resultWarning: updateData.resultWarning || undefined,
        isScaleTask: parseInt(updateData.isScaleTask !== undefined ? updateData.isScaleTask : 1),
        remark: updateData.remark || undefined,
        taskPublishTime: updateData.taskPublishTime ? formatDateTime(updateData.taskPublishTime) : undefined,
        submitTime: updateData.submitTime ? formatDateTime(updateData.submitTime) : undefined,
        deadline: updateData.deadline ? formatDateTime(updateData.deadline) : undefined,
        deleted: parseInt(updateData.deleted || 0),
        updateTime: formatDateTime(new Date())
      }

      // 合并数据，过滤掉undefined的字段
      const requestData = { ...baseRequestData }
      Object.keys(optionalFields).forEach(key => {
        if (optionalFields[key] !== undefined) {
          requestData[key] = optionalFields[key]
        }
      })

      console.log('发送更新量表任务记录请求数据:', requestData)

      // 尝试多个可能的API端点
      let response
      let usedEndpoint = ''
      let lastError = null

      // 端点列表，按优先级排序
      const endpoints = [
        { method: 'put', url: '/scale/response/update', description: '标准更新接口' },
        { method: 'post', url: '/scale/response/update', description: 'POST更新接口' },
        { method: 'put', url: '/scale/task/update', description: '任务更新接口' },
        { method: 'post', url: '/scale/task/update', description: 'POST任务更新接口' },
        { method: 'put', url: '/scale/record/update', description: '记录更新接口' },
        { method: 'post', url: '/scale/record/update', description: 'POST记录更新接口' },
        { method: 'put', url: '/api/scale/task/update', description: 'API路径任务更新接口' },
        { method: 'post', url: '/api/scale/task/update', description: 'API路径POST任务更新接口' },
        { method: 'put', url: '/scale/update', description: '简化更新接口' },
        { method: 'post', url: '/scale/update', description: 'POST简化更新接口' }
      ]

      // 如果第一轮尝试失败，准备字符串格式的备用数据
      const prepareStringFormatData = (data) => {
        const stringData = {}
        Object.keys(data).forEach(key => {
          const value = data[key]
          if (value !== null && value !== undefined) {
            if (typeof value === 'number') {
              stringData[key] = value.toString()
            } else {
              stringData[key] = value
            }
          }
        })
        return stringData
      }

      for (const endpoint of endpoints) {
        try {
          console.log(`尝试${endpoint.description}: ${endpoint.method.toUpperCase()} ${endpoint.url}`)
          console.log('发送的请求数据:', JSON.stringify(requestData, null, 2))

          if (endpoint.method === 'put') {
            response = await apiClient.put(endpoint.url, requestData)
          } else {
            response = await apiClient.post(endpoint.url, requestData)
          }

          usedEndpoint = `${endpoint.method.toUpperCase()} ${endpoint.url}`
          console.log(`${endpoint.description}调用成功`)
          break // 成功就退出循环
        } catch (endpointError) {
          console.log(`${endpoint.description}失败:`, endpointError.message)
          lastError = endpointError

          // 记录详细错误信息
          if (endpointError.response) {
            console.error('服务器错误详情:')
            console.error('- 状态码:', endpointError.response.status)
            console.error('- 响应数据:', endpointError.response.data)
            console.error('- 请求URL:', `${endpoint.method.toUpperCase()} ${endpoint.url}`)
            console.error('- 请求数据:', JSON.stringify(requestData, null, 2))

            // 特别处理500错误
            if (endpointError.response.status === 500) {
              console.error('🚨 服务器内部错误分析:')
              console.error('- 状态码: 500 Internal Server Error')
              console.error('- 端点:', `${endpoint.method.toUpperCase()} ${endpoint.url}`)
              console.error('- 发送数据:', JSON.stringify(requestData, null, 2))

              const errorResponse = endpointError.response.data
              if (errorResponse) {
                console.error('- 服务器错误详情:', errorResponse)

                // 分析可能的错误原因
                if (errorResponse.message) {
                  console.error('- 错误消息:', errorResponse.message)

                  // 检查是否是医生患者绑定问题
                  if (errorResponse.message.includes('绑定') || errorResponse.message.includes('bind') || errorResponse.message.includes('relationship')) {
                    console.error('🔍 可能是医生患者绑定关系问题:')
                    console.error('  1. 医生ID和患者ID之间没有绑定关系')
                    console.error('  2. 绑定关系已失效或被删除')
                    console.error('  3. 权限验证失败')
                    console.error('💡 建议: 请检查医生(ID:' + requestData.doctorId + ')和患者(ID:' + requestData.userId + ')的绑定关系')
                  }

                  // 检查数据格式问题
                  if (errorResponse.message.includes('format') || errorResponse.message.includes('格式') || errorResponse.message.includes('类型')) {
                    console.error('🔍 可能是数据格式问题:')
                    console.error('  1. 数值类型字段包含非数字内容')
                    console.error('  2. 时间格式不符合要求')
                    console.error('  3. 字符串长度超出限制')
                  }

                  // 检查数据库约束问题
                  if (errorResponse.message.includes('constraint') || errorResponse.message.includes('约束') || errorResponse.message.includes('duplicate')) {
                    console.error('🔍 可能是数据库约束问题:')
                    console.error('  1. 唯一性约束冲突')
                    console.error('  2. 外键约束失败')
                    console.error('  3. 非空约束违反')
                  }
                }
              }

              console.error('🔧 可能的解决方案:')
              console.error('1. 检查所有必填字段是否完整')
              console.error('2. 验证数据类型是否正确')
              console.error('3. 确认医生患者绑定关系')
              console.error('4. 检查时间格式: YYYY-MM-DD HH:mm:ss')
              console.error('5. 验证权限和认证状态')
            }
          } else if (endpointError.request) {
            // 请求已发出但没有收到响应
            console.error('🌐 网络错误 - 请求已发出但没有收到响应:')
            console.error('可能的原因:')
            console.error('1. 网络连接问题 - 检查网络连接')
            console.error('2. 服务器未启动或不可达 - 确认后端服务状态')
            console.error('3. CORS跨域问题 - 请重启开发服务器')
            console.error('4. 防火墙阻止 - 检查防火墙设置')
            console.error('5. 请求超时 - 检查服务器响应时间')
          } else {
            // 其他错误
            console.error('⚠️ 请求配置错误:', endpointError.message)
            console.error('可能的原因:')
            console.error('1. axios配置错误')
            console.error('2. 请求URL格式错误')
            console.error('3. 请求参数格式错误')
          }

          // 如果是404，继续尝试下一个端点
          if (endpointError.response?.status === 404) {
            continue
          }

          // 如果是其他错误且不是最后一个端点，也继续尝试
          if (endpoints.indexOf(endpoint) < endpoints.length - 1) {
            continue
          }

          // 如果是最后一个端点，抛出错误
          throw endpointError
        }
      }

      // 如果第一轮失败，首先尝试最简化数据格式
      if (!response && lastError && lastError.response?.status === 500) {
        console.warn('🔄 第一轮尝试失败，开始故障排除流程...')

        // 步骤1: 尝试最简化数据（只包含绝对必要的字段）
        console.log('步骤1: 尝试最简化数据格式...')
        const minimalData = {
          id: parseInt(updateData.id),
          userId: parseInt(updateData.userId),
          doctorId: parseInt(updateData.doctorId),
          scaleId: parseInt(updateData.scaleId),
          status: updateData.status || '未完成'
        }

        // 只添加有明确值的关键字段
        if (updateData.remark && updateData.remark.trim()) {
          minimalData.remark = updateData.remark.trim()
        }

        console.log('最简化数据:', JSON.stringify(minimalData, null, 2))

        // 优先尝试最常用的端点
        const priorityEndpoints = [
          { method: 'put', url: '/scale/response/update', description: '标准更新接口' },
          { method: 'post', url: '/scale/update', description: 'POST简化更新接口' }
        ]

        for (const endpoint of priorityEndpoints) {
          try {
            console.log(`最简化数据尝试 ${endpoint.description}: ${endpoint.method.toUpperCase()} ${endpoint.url}`)

            if (endpoint.method === 'put') {
              response = await apiClient.put(endpoint.url, minimalData)
            } else {
              response = await apiClient.post(endpoint.url, minimalData)
            }

            usedEndpoint = `${endpoint.method.toUpperCase()} ${endpoint.url} (最简化数据)`
            console.log(`✅ 最简化数据 ${endpoint.description} 调用成功`)
            break
          } catch (minimalError) {
            console.log(`❌ 最简化数据 ${endpoint.description} 失败:`, minimalError.message)
            lastError = minimalError
          }
        }

        // 步骤2: 如果最简化数据也失败，尝试字符串格式
        if (!response) {
          console.log('步骤2: 最简化数据失败，尝试字符串格式...')
          const stringRequestData = prepareStringFormatData(requestData)
          console.log('字符串格式请求数据:', JSON.stringify(stringRequestData, null, 2))

          for (const endpoint of endpoints) {
            try {
              console.log(`字符串格式重试${endpoint.description}: ${endpoint.method.toUpperCase()} ${endpoint.url}`)

              if (endpoint.method === 'put') {
                response = await apiClient.put(endpoint.url, stringRequestData)
              } else {
                response = await apiClient.post(endpoint.url, stringRequestData)
              }

              usedEndpoint = `${endpoint.method.toUpperCase()} ${endpoint.url} (字符串格式)`
              console.log(`字符串格式${endpoint.description}调用成功`)
              break
            } catch (retryError) {
              console.log(`字符串格式${endpoint.description}失败:`, retryError.message)
              lastError = retryError
            }
          }
        }
      }

      if (!response) {
        throw lastError || new Error('所有API端点都无法访问')
      }

      // 处理响应数据，与其他API方法保持一致
      const data = response.data
      console.log(`更新量表任务记录API响应详情 (${usedEndpoint}):`, data)

      if (data.code === 0) {
        return {
          success: true,
          message: data.message || '量表任务记录更新成功',
          data: data.data || {},
          usedEndpoint
        }
      } else {
        return {
          success: false,
          message: data.message || '更新量表任务记录失败',
          data: null,
          usedEndpoint
        }
      }
    } catch (error) {
      console.error('更新量表任务记录异常:', error)

      if (error.response) {
        // 服务器返回了错误响应
        const errorData = error.response.data
        return {
          success: false,
          message: errorData?.message || `服务器错误: ${error.response.status}`,
          data: null,
          usedEndpoint: error.config?.baseURL || 'unknown'
        }
      } else if (error.request) {
        // 请求发送但没有收到响应
        return {
          success: false,
          message: '网络连接超时，请检查网络设置',
          data: null,
          usedEndpoint: 'network_error'
        }
      } else {
        // 其他错误
        return {
          success: false,
          message: error.message || '更新量表任务记录时发生未知错误',
          data: null,
          usedEndpoint: 'unknown_error'
        }
      }
    }
  }

  /**
   * 查询患者历史方案
   * @param {string} patientId - 患者ID
   * @returns {Promise<Object>} 患者历史方案列表
   */
  async getPatientSchemeHistory(patientId) {
    try {
      console.log('查询患者历史方案:', patientId)

      if (!patientId) {
        return {
          success: false,
          message: '患者ID不能为空'
        }
      }

      let response = null
      let lastError = null
      let usedEndpoint = null

      // 尝试多个API端点
      for (const apiInstance of this.apiInstances) {
        try {
          console.log(`尝试查询患者历史方案 - 端点: ${apiInstance.defaults.baseURL}`)

          response = await apiInstance.get('/patient/scheme/history', {
            params: { patientId },
            timeout: 10000
          })

          usedEndpoint = apiInstance.defaults.baseURL
          console.log(`患者历史方案查询成功 - 端点: ${usedEndpoint}`)
          break
        } catch (error) {
          console.error(`查询患者历史方案失败 - 端点: ${apiInstance.defaults.baseURL}`, error.message)
          lastError = error
          continue
        }
      }

      if (!response) {
        throw lastError || new Error('所有API端点都无法访问')
      }

      // 检查响应数据结构
      const data = response.data
      console.log(`查询患者历史方案API响应详情 (${usedEndpoint}):`, data)

      // 根据接口文档，code为0表示成功
      if (data.code === 0) {
        return {
          success: true,
          message: data.message || '查询患者历史方案成功',
          data: data.data || [],
          usedEndpoint
        }
      } else {
        // 查询失败
        const errorMessage = data.message || '查询患者历史方案失败'
        console.warn('查询患者历史方案失败:', errorMessage)

        return {
          success: false,
          message: errorMessage,
          errorCode: data.code,
          data: null,
          usedEndpoint
        }
      }
    } catch (error) {
      console.error('查询患者历史方案异常:', error)

      if (error.response) {
        // 服务器返回了错误响应
        const errorData = error.response.data
        return {
          success: false,
          message: errorData?.message || `服务器错误: ${error.response.status}`,
          data: null,
          usedEndpoint: error.config?.baseURL || 'unknown'
        }
      } else if (error.request) {
        // 请求发送但没有收到响应
        return {
          success: false,
          message: '网络连接超时，请检查网络设置',
          data: null,
          usedEndpoint: 'network_error'
        }
      } else {
        // 其他错误
        return {
          success: false,
          message: error.message || '查询患者历史方案时发生未知错误',
          data: null,
          usedEndpoint: 'unknown_error'
        }
      }
    }
  }
}

// 创建量表API实例
export const scaleApi = new ScaleApi()

// 默认导出
export default scaleApi
